export default __webpack_public_path__ + "static/media/dgm01-OCIO_DBHIDS-Data-Governance-Framework-Implementation-Plan-v1(2016).ed1b415e.pdf";